export const PROJECTS_NAVIGATION = "projects-navigation";
export const CHEVRON_ICON_COLLAPSE = "chevron-icon-collapse";
export const CHEVRON_CONTAINER = "chevron-container";
export const PROJECT_MENU = "project-menu";
